<template>
  <div class="mobile-settings">
    <b-card title="Paramètres Mobile" class="mb-4">
      <b-card-text>
        Configurez la version minimale requise de l'application mobile LeRefuge.
        Les utilisateurs avec une version antérieure seront invités à la mettre à jour.
      </b-card-text>
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col md="6">
            <b-form-group label="Version minimale requise" label-for="mobile-version">
              <b-form-input
                id="mobile-version"
                v-model="mobileVersion"
                placeholder="Ex: 1.0.0"
                :state="validationState"
              />
              <b-form-invalid-feedback>
                Format invalide. La version doit respecter le système de numérotation sémantique (ex: 1.0.0, 1.0.0-alpha+001).
              </b-form-invalid-feedback>
              <small class="text-muted d-block mt-50">
                Format attendu: numérotation sémantique (ex: 1.0.0, 1.0.0-alpha+001).
              </small>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-button type="submit" variant="primary" :disabled="isLoading || !isValidVersion">
              <b-spinner v-if="isLoading" small class="mr-50" />
              <feather-icon v-else icon="SaveIcon" class="mr-50" />
              Enregistrer
            </b-button>
          </b-col>
        </b-row>
      </b-form>

      <hr class="my-2">

      <div class="current-version-info">
        <h6>Version actuelle configurée</h6>
        <p v-if="currentVersion" class="mb-0">
          <feather-icon icon="SmartphoneIcon" class="mr-50" />
          <strong>{{ currentVersion }}</strong>
        </p>
        <p v-else class="text-muted mb-0">
          Aucune version configurée
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import { ref, computed, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'

export default {
  components: {
    BCard,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  setup() {
    const toast = useToast()
    const mobileVersion = ref('')
    const currentVersion = computed(() => store.getters['mobileVersion/mobileVersion'])
    const isLoading = ref(false)

    const versionRegex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/

    const isValidVersion = computed(() => versionRegex.test(mobileVersion.value))

    const validationState = computed(() => {
      if (!mobileVersion.value) {
        return null
      }

      return isValidVersion.value
    })

    const fetchCurrentVersion = async () => {
      try {
        await store.dispatch('mobileVersion/fetchMobileVersion')
        mobileVersion.value = store.getters['mobileVersion/mobileVersion']
      } catch (error) {
        console.error('Erreur lors de la récupération de la version:', error)
      }
    }

    const onSubmit = async () => {
      if (!isValidVersion.value) {
        return
      }

      isLoading.value = true
      try {
        console.log('version :', mobileVersion.value)
        await store.dispatch('mobileVersion/updateMobileVersion', mobileVersion.value)

        toast({
          component: ToastificationContent,
          props: {
            title: 'Version mise à jour',
            text: `La version mobile minimale a été définie à ${mobileVersion.value}`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Erreur lors de la mise à jour:', error)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erreur',
            text: 'Impossible de mettre à jour la version mobile',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isLoading.value = false
      }
    }

    onMounted(() => {
      fetchCurrentVersion()
    })

    return {
      mobileVersion,
      currentVersion,
      isLoading,
      isValidVersion,
      validationState,
      onSubmit,
    }
  },
}
</script>

<style lang="scss" scoped>
.mobile-settings {
  max-width: 800px;
  margin: 0 auto;
}

.current-version-info {
  background-color: rgba(115, 103, 240, 0.08);
  padding: 1rem;
  border-radius: 0.428rem;
}
</style>
